<script module lang="ts">
    import type { HTMLTextareaAttributes } from 'svelte/elements';
    import type { Field } from '@/types/types';

    export type Props = {
        label?: string | null;
        name?: string | null;
        value?: string | null;
        error?: string | null;
        description?: string | null;
        args?: HTMLTextareaAttributes;
        class?: string;
        field?: Field;
    };
</script>

<script lang="ts">
    import { Textarea } from '@/components/ui/textarea/index.js';
    import InputError from '@/components/InputError.svelte';
    import { Label } from '@/components/ui/label/index.js';
    import { cn } from '@/lib/utils';
    import FieldDescription from './FieldDescription.svelte';

    let {
        label,
        name,
        value = $bindable(),
        error,
        class: className,
        description,
        field,
        ...args
    }: Props = $props();

    const computedName = $derived(field?.column_name ?? name);

    // Compute CSS classes - include server errors
    const validationClasses = $derived(() => {
        if (error) {
            return 'input-error';
        }
        if (value && value.toString().trim().length > 0) {
            return 'input-success';
        }
        return '';
    });
</script>

<div class={cn('grid gap-2 w-full', className)}>
    {#if label}
        <Label for={label}>{label}{#if field?.required}<span class="text-destructive">*</span>{/if}</Label>
    {/if}
    {#if description}
        <FieldDescription>{description}</FieldDescription>
    {/if}
    <Textarea id={label} name={computedName} bind:value class={validationClasses()} {...args} />
    <InputError class="mt-2" message={error} />
</div>
